import { NgZone, ChangeDetectorRef } from '@angular/core';
import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { PetProcsModel } from '../../../models/pet-proc.model';
import { CatalogService } from '../../../services/catalog.service';
import { CodesFileModel } from '../../../models/codes-file.model';
import { INVENT, LETTER_PROC, NOMED } from '../../../../environments/environment';
import { CheckPetSexSpecieModel } from '../../../models/check-pet-sex-specie.model';
import { PetBriefModel } from '../../../models/pet-brief.model';
import { ClientService } from '../../../services/client.service';
import { TranRecordModel } from '../../../models/tran-record.model';
import { ProcCostModel } from '../../../models/proc-cost.model';
import { ProcedureService } from '../../../services/procedure.service';
import { DeleteATranModel } from '../../../models/delete-a-tran.model';
import { HandleCorSModel } from '../../../models/handle-cors.model';
import { UpdateStatusModel } from '../../../models/update-status.model';
import { TranDynOptModel } from '../../../models/tran-dyn-opt.model';
import { GetChildPriceModel } from '../../../models/get-child-price.model';
import { HandleInvtModel } from '../../../models/handle-invt.model';
import { UpdateTranInfoModel } from '../../../models/update-tran-info.model';
import { GetProcLinkModel, LinkRecordModel } from '../../../models/get-proc-link.model';
import { BuildTransactModel } from '../../../models/build-transact.model';
import { UpdateTranModel } from '../../../models/update-tran.model';
import { DosageModel } from '../../../models/dosage.model';
import { CalcDosageModel } from '../../../models/calc-dosage.model';
import { SubTranRecordModel } from '../../../models/sub-tran-record.model';
import { SaveSubTranModel } from '../../../models/save-sub-tran.model';
import { UpdatePStatusModel } from '../../../models/update-pstatus.model';
import { CheckBaseChargeModel } from '../../../models/check-base-charge.model';
import { GetResponseModel } from '../../../models/get-response.model';
import { TreatGenModel } from '../../../models/treat-gen.model';
import { RefundProcModel } from '../../../models/refund-proc.model';
import { TreatmentProcModel } from '../../../models/treatment-proc.model';
import Swal from 'sweetalert2';
import { TxSetupModel } from '../../../models/tx-setup.model';
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { RespNotesModel } from '../../../models/resp-notes.model';


declare var $: any;


@Component({
    selector: 'ngx-work-procedures',
    styleUrls: ['./procedures.component.scss'],
    templateUrl: './procedures.component.html',
})

export class ProceduresComponent implements OnInit, OnDestroy {

    private _pet_no: number;
    private currentRequest: any = null; // Track current request
    edit = false;
    viewing = false;
    buscador_activo = false;
    buscador_activo_status = false;
    suggestedWordsArray: CodesFileModel[] = [];
    status = [];
    filteredItems: any[];
    txt_ProcCode: any;
    txt_stat: any;
    isButtonClicked: boolean = true;
    LETTER_PROC = LETTER_PROC;

    // EST → PVL batch transfer queue
    estItemQueue: PetProcsModel[] = [];
    isBatchTransfer: boolean = false;

    filteredTable: PetProcsModel[];
    filterDD: any;
    estimateText: any;

    txt_NoPerDay: any;
    txt_Startdate: any;
    txt_AltDays: any;
    txt_NoOfTimes: any;
    txtchar: any;
    filterText: string;
    isChild: boolean;
    parent: PetProcsModel;

    Categories: any[] = [];
    Approvals: any[];
    Types: any[];
    SubCategories: any[];
    Fix: any[];

    //TREATMENT MODAL//////////////////////////////////////////////////////////////////////
    TreatmentItem: PetProcsModel;

    //RESP NOTES MODAL////////////////////////////////////////////////////////////////////
    respNotes: RespNotesModel[] = [];

    public isLoading: boolean = false;

    @Input() set pet_no(value: number) {
        const num = value ?? this.petService.current_pet_no;
        if (!num || num <= 0) {
            this._pet_no = value;
            this.filteredTable = [];
            return;
        }
        const changed = num !== this._pet_no;
        this._pet_no = value;
        if (!changed) return;

        this.isLoading = true;
        this.filteredTable = [];

        this.loadProceduresForCurrentPet(num)
            .then(() => { this.isLoading = false; });
    }

    get pet_no(): number {
        return this._pet_no;
    }

    /**
     * Carga los procedimientos de la mascota actual y actualiza filteredTable.
     * Se ejecuta automáticamente cuando cambia pet_no (current_pet.pet_no).
     */
    private loadProceduresForCurrentPet(petNo?: number): Promise<void> {
        const id = petNo ?? this.petService.current_pet_no;
        return this.petService.getProcsByPetId(id).then(() => {
            this.filteredTable = this.petService.pet_procs;
        });
    }

    private async loadAndRestoreVisible(): Promise<void> {
        const visibleSeqs = new Set(
            (this.filteredTable || [])
                .filter(item => item.visible)
                .map(item => item.tran_sequence)
        );
        await this.loadProceduresForCurrentPet();
        if (visibleSeqs.size > 0) {
            this.filteredTable.forEach(item => {
                if (visibleSeqs.has(item.tran_sequence)) {
                    item.visible = true;
                }
            });
        }
    }

    constructor(
        public petService: PetService,
        public clientService: ClientService,
        public procedureService: ProcedureService,
        private route: ActivatedRoute,
        public catalogService: CatalogService,
        public datePipe: DatePipe,
        private ngZone: NgZone,
        private cdr: ChangeDetectorRef
    ) {
        this.status.push(...LETTER_PROC);

    }


    onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
    }

    async admitted() {
        $('#modalAddProc').modal('show')
        await this.procedureService.admitted('valor');
    }


    ngOnInit() {
        console.log('PROCEDURE RUN');
        Swal.fire({
            title: 'Loading...',
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })

        this.petService.changePet
            .subscribe(message => {
                if (message !== this.pet_no) {
                    this.pet_no = message;
                }
            });

        setTimeout(() => {
            this.codes_file.push(...this.catalogService.codes_file);
            Swal.close();
        }, 100);

        this.procedureService.observable1 = this.procedureService.selectedFinishGeneric
            .subscribe(message => {
                if (message) {
                    this.procedureService.selectedFinishGenericVar(false); // reset the observable value
                    this.loadProceduresForCurrentPet().then(() => {
                        if (this.isBatchTransfer) {
                            // batch mode: process next item silently, show summary at end
                            if (this.estItemQueue.length > 0) {
                                this.processNextEstItem();
                            } else {
                                this.isBatchTransfer = false;
                                Swal.fire({ title: 'Transfer complete.' });
                            }
                        } else {
                            Swal.fire({
                                title: 'Information stored correctly',
                            });
                        }
                    });
                }
            });

        this.petService.ProcedureObservable.subscribe((item) => {
            this.filterText = item.pr_code
            this.txtchar = item.pr_status.toUpperCase();

            console.log("received here", this.filterText, this.txtchar);
            this.AddProcedure();
        });

        this.procedureService.notify_FromEstModalObservable.subscribe((procs: PetProcsModel[]) => {
            console.log("received from est modal", procs);
            this.estItemQueue = [...procs];
            this.isBatchTransfer = procs.length > 1;
            this.processNextEstItem();
        });

        this.procedureService.notify_InitProcTableModalObservable.subscribe(() => {
            this.loadProceduresForCurrentPet();
        });

        this.procedureService.respNotes$.subscribe(notes => {
            if (notes && notes.length > 0 && !$('#modalRespNotes').hasClass('show')) {
                this.respNotes = notes;
                $('#modalRespNotes').modal('show');
            }
        });

    }


    ngOnDestroy(): void {
        if (this.procedureService.observable1)
            this.procedureService.observable1.unsubscribe();

        // Clean up current request
        if (this.currentRequest) {
            this.currentRequest.unsubscribe();
            this.currentRequest = null;
        }
    }

    add() {
        $('#modalAddProc').modal('show')
    }

    invented() {
        $('#modalInventProcedure').modal('show')
    }

    openEditProc(item: PetProcsModel): void {
        this.procedureService.selectedEditProcVar(item);
        $('#modalEditProcedure').modal('show');
    }
    filterByStatus(selectedStat: any) {
        if (selectedStat == 'A') {
            this.filteredTable = this.petService.pet_procs
        }
        else {
            let petprocfilter = this.petService.pet_procs
            this.filteredTable = petprocfilter.filter(item => item.status.includes(selectedStat));
        }

        let curentPetNoStr = this.petService.current_pet_no
        this.petService.getEstimateProc(curentPetNoStr.toString(), selectedStat, '1').then((totalEst) => {
            console.log(this.petService.current_pet_no); // Access the result here
            this.estimateText = totalEst
        })
    }

    view(item: PetProcsModel, parent: PetProcsModel = undefined) {
        this.edit = false;
        item.visible = !item.visible;
        this.petService.pet_proc = item;
    }

    back() {
        this.petService.pet_proc = this.parent;
        this.isChild = false;
    }

    async proc() {
        if (this.petService.pet_visit.assigned_doctor && this.petService.pet_visit.assigned_doctor === '') {
            Swal.fire({
                title: 'Please assign attending doctor before requesting items.',
                didOpen: () => {
                },
            })
            return;
        }
        switch (this.txtchar) {
            case 'O':
                // OnlineOrder
                break;
            case 'C':
            case 'D':
            case 'E':
            case 'F':
            case 'P':
            case 'R':
            case 'S':
            case 'T':
            case 'W':
            case 'Q':
                //RequestProc
                // Swal.fire({
                //     title: 'Loading...',
                //     timerProgressBar: true,
                //     didOpen: () => {
                //         Swal.showLoading()
                //     },
                // })

                this.procedureService.strCodeName = this.filterText;
                this.procedureService.txtchar = this.txtchar;
                this.procedureService.lngPetNo = this.petService.pet.pet_no;

                $('#modalAddProc').modal('hide')

                let code = this.catalogService.codes_file.find(t => t.code_name === this.filterText);
                if (code && code.code_type < 0) {
                    Swal.fire({
                        title: `Code Not Found`,
                        text: `Invalid code type for ${this.filterText}`,
                        didOpen: () => {
                        },
                    })
                    return;
                }

                let intCodeType = code.code_type;

                if (intCodeType === undefined) {
                    Swal.fire({
                        title: `Code Not Found`,
                        text: `Invalid code type for ${this.filterText}`,
                        didOpen: () => {
                        },
                    })
                    return;
                }

                this.procedureService.check_pss = new CheckPetSexSpecieModel(code.code_no, code.code_type, this.petService.current_pet_no, INVENT, 1, '', 0);
                await this.procedureService.checkPetSexSpecie()
                    .then(() => {
                    });

                if (this.procedureService.check_pss.check === 1) {
                } else {
                    Swal.fire({
                        title: this.procedureService.check_pss.message,
                        didOpen: () => {
                        },
                    })
                    return;
                }

                this.procedureService.selectedGenericVar(true);
                $('#modalAddProcedure').modal('show')

                // var intIdx = await this.requestProc(this.procedureService.displayTran(this.petService.pet_procs), -1, this.petService.pet_procs.length, this.filterText,
                //     this.txtchar, 'ref', 1, this.petService.pet.client_no, this.petService.pet.pet_no, 0);
                // console.log(intIdx);
                // if (intIdx.RequestProc > 0)
                //     this.petService.getProcsByPetId(this.petService.current_pet_no)
                //         .then(() => {
                //             this.filteredTable = this.petService.pet_procs;
                //             Swal.fire({
                //                 title: 'Information stored correctly',
                //             })
                //         });
                this.clearinput();
                return;
            default:
                break;
        }

        this.clearinput();
        $('#modalProcRefer').modal('hide')
    }

    async AddProcedure() {
        let code: CodesFileModel;

        switch (this.txtchar) {
            case '*': //AddVaccine
                code = this.catalogService.codes_file.find(t => t.code_name === this.filterText);
                console.log(this.filterText, code);

                if (this.catalogService.clinic_code.some(t => t.pet_info_proc_no === code.code_no && t.pet_info_proc_type === code.code_type)) {
                    // Enter ID Chip Number for this patient.
                    // Swal.fire({
                    //     text: 'Enter ID Chip Number for this patient.',
                    //     input: 'text',
                    //     inputAttributes: {
                    //         autocapitalize: 'off',
                    //         autocomplete: 'off',
                    //     },
                    //     showCancelButton: true,
                    //     confirmButtonText: 'Save'
                    // }).then((result) => {
                    //     if (result.isConfirmed) {
                    //         Swal.fire({
                    //             title: `ID Chip: ${result.value.login}`,
                    //             imageUrl: result.value.avatar_url
                    //         })
                    //     }
                    // })
                    $('#modalAddProc').modal('hide')
                    return;
                }

                let brief_history_category = code.brief_history_category.trim();
                if (brief_history_category === '') {
                    // Brief history category not found for this code.
                    Swal.fire({
                        title: 'Brief history c ategory not found for this code.',
                        didOpen: () => {
                        },
                    })
                    return;
                }

                Swal.fire({
                    title: 'Loading...',
                    timerProgressBar: true,
                    didOpen: () => {
                        Swal.showLoading()
                    },
                })

                this.procedureService.check_pss = new CheckPetSexSpecieModel(code.code_no, code.code_type, this.petService.current_pet_no, INVENT, 1, '', 0);
                this.procedureService.checkPetSexSpecie()
                    .then(() => {
                        Swal.close();

                        if (this.procedureService.check_pss.check === 1) {
                            $('#modalAddProc').modal('hide')
                            $('#modalAddVaccine').modal('show')
                        } else {
                            Swal.fire({
                                title: this.procedureService.check_pss.message,
                                didOpen: () => {
                                },
                            })
                            return;
                        }

                    });

                break;
            case '$': //PriceLookup
                code = this.catalogService.codes_file.find(t => t.code_name === this.filterText);
                if (code.code_type !== INVENT) {
                    //Price lookup feature can only be used on inventory codes.
                    Swal.fire({
                        title: 'Price lookup feature can only be used on inventory codes.',
                        didOpen: () => {
                        },
                    })
                    return;
                }

                let LTrans: TranRecordModel[] = Array(2).fill(new TranRecordModel());
                let intTotal = 1
                let intIndex = -1

                let result = await this.requestProc(LTrans, intIndex, intTotal, this.filterText, 'R', 'ref', 1, this.clientService.current_client_no, this.petService.current_pet_no, 0);
                if (result.RequestProc >= 0) {
                    if (LTrans[intIndex].Attending <= 0) {
                        //UpdateDocs
                    }

                    let DoneProc = true; //****
                    if (DoneProc) {
                        Swal.fire({
                            title: `Price Lookup`,
                            text: `Price of ${LTrans[intIndex].LinkName} is ${LTrans[intIndex].Cost}`,
                            didOpen: () => {
                            },
                        }).then(() => {
                            //DeleteATran
                        });
                    } else {
                        Swal.fire({
                            text: `Could not calculate price for ${this.filterText}.`,
                            didOpen: () => {
                            },
                        })
                    }
                } else {
                    Swal.fire({
                        text: `Could not request ${this.filterText} for a price look up.`,
                        didOpen: () => {
                        },
                    })
                }
                break;
            default:
                this.proc();
                break;
        }
        // if (this.txtchar == 'O') {
        //     console.log("for O")
        // }
        // else if (this.txtchar == "C" || this.txtchar == "D" || this.txtchar == "E" || this.txtchar == "F" ||
        //     this.txtchar == "P" || this.txtchar == "R" || this.txtchar == "S" || this.txtchar == "T" || this.txtchar == "W" ||
        //     this.txtchar == "Q") {
        //     console.log("for C,D,E, etc.")
        // }


    }

    async requestProc(Trans: TranRecordModel[], intIndex: number, intTotalIdx: number, strCodeName: string, strStatus: string, strReqEmp: string, intEmpNo: number,
        lngClientNo: number, lngPetNo: number, lngSupSeq: number, sglPrice?: number, sglLUnit?: number, strLFix?: string, strLChk?: string) {
        return await this.procedureService.requestProc(Trans, intIndex, intTotalIdx, strCodeName, strStatus, strReqEmp, intEmpNo,
            lngClientNo, lngPetNo, lngSupSeq, sglPrice, sglLUnit, strLFix, strLChk);
    }

    getParentCode(lngSupSeq: number, intPIdx: number) {
        if (this.petService.pet_procs.some(t => t.sup_sequence === lngSupSeq)) {
            var t = this.petService.pet_procs.find(t => t.sup_sequence === lngSupSeq);
            var intPIdx = this.petService.pet_procs.findIndex(t => t.sup_sequence === lngSupSeq);
            return t.link_no;
        }
    }

    select(item: CodesFileModel) {
        this.filterText = item.code_name;
        this.petService.pet_proc.code_no = item.code_no;
        this.petService.pet_proc.code_type = item.code_type;
        this.petService.pet_proc.code_name = item.code_name;
        this.petService.pet_proc.procedure_desc = item.procedure_desc;
        this.suggestedWordsArray = [];
        this.buscador_activo = this.suggestedWordsArray.length > 0;
        this.buscador_activo_status = true;
        //  debugger;
    }

    search(event: any) {
        this.txtchar = '';

        setTimeout(() => {
            this.petService.pet_proc.code_name = event.target.value;

            if (event.key === 'Backspace' || event.key === 'Delete') {
                this.suggestedWordsArray = [];
                this.buscador_activo = false;
            }

            if (this.petService.pet_proc.code_name.length > 0) {
                this.suggestedWordsArray = [];
                const searchTerm = this.petService.pet_proc.code_name.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "");
                this.suggestedWordsArray.push(...this.filterArray(this.catalogService.codes_file, searchTerm, 'code_name'));
                this.suggestedWordsArray.push(...this.filterArray(this.catalogService.codes_file, searchTerm, 'code_category').filter(item => !this.suggestedWordsArray.some(x => x.code_no === item.code_no)));
                this.suggestedWordsArray.push(...this.filterArray(this.catalogService.codes_file, searchTerm, 'code_sub_category').filter(item => !this.suggestedWordsArray.some(x => x.code_no === item.code_no)));
                this.suggestedWordsArray.push(...this.filterArray(this.catalogService.codes_file, searchTerm, 'procedure_desc').filter(item => !this.suggestedWordsArray.some(x => x.code_no === item.code_no)));
                this.suggestedWordsArray.push(...this.filterArray(this.catalogService.codes_aliases, searchTerm, 'procedure_desc').filter(item => !this.suggestedWordsArray.some(x => x.code_no === item.code_no)));

                if (this.catalogService.codes_vendor.some(t => t.vendor.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "").includes(this.petService.pet_proc.code_name.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "")))) {
                    var vendor = this.catalogService.codes_vendor.find(t => t.vendor.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "").includes(this.petService.pet_proc.code_name.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "")));
                    this.suggestedWordsArray.push(...this.codes_file.filter(t => vendor.codes.some(v => v == t.code_no)));
                }

                this.buscador_activo = this.suggestedWordsArray.length > 0;
            } else {
                this.suggestedWordsArray = [];
                this.buscador_activo = this.suggestedWordsArray.length > 0;
            }
        }, 100);
    }

    filterArray(array: CodesFileModel[], item: string, field: string) {
        return array
            .filter((word: CodesFileModel) => this.compareTwoStrings(word[`${field}`].normalize("NFD").replace(/[\u0300\u0301]/g, ""), item))
            .sort((a: CodesFileModel, b: CodesFileModel) => {
                if (a[`${field}`].toLowerCase() < b[`${field}`].toLowerCase()) {
                    return -1;
                }
                if (a[`${field}`].toLowerCase() > b[`${field}`].toLowerCase()) {
                    return 1;
                }
                return 0;
            });
    }

    compareTwoStrings(string: any, subString: any) {
        if (string.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "").includes(subString)) return subString;
    }

    filterItems() {
        let code_namefilter = this.catalogService.codes_file
        this.filterText = this.filterText.toUpperCase();
        this.filteredItems = code_namefilter.filter(item => item.code_name.includes(this.filterText));
        console.log(this.filterText);
        this.isButtonClicked = false;
    }

    onStatInput() {
        this.txtchar = this.txtchar.toUpperCase();
        this.AddProcedure()
    }

    onStatusSelected(target, formAddProcedures: NgForm) {
        //console.log(target, formAddProcedures);
        this.buscador_activo_status = false;
        if (formAddProcedures.valid) {
            formAddProcedures.ngSubmit.emit();
        }
    }

    onOptionsSelected(target: any) {
        let arr = [];
        this.catalogService.codes_file.forEach(element => {
            if (element.code_category)
                arr.push(element.code_category);
        });
        var unique = arr.filter(this.onlyUnique);
        this.Categories = unique.sort((a, b) => (a < b) ? -1 : 1);

        arr = [];
        this.catalogService.codes_file.forEach(element => {
            if (element.code_category)
                arr.push(element.code_sub_category);
        });
        var unique = arr.filter(this.onlyUnique);
        this.SubCategories = unique.sort((a, b) => (a < b) ? -1 : 1);

        arr = [];
        this.catalogService.codes_file.forEach(element => {
            if (element.code_category)
                arr.push(element.code_approval);
        });
        var unique = arr.filter(this.onlyUnique);
        this.Approvals = unique.sort((a, b) => (a < b) ? -1 : 1);

        arr = [];
        this.catalogService.codes_file.forEach(element => {
            if (element.code_category)
                arr.push(element.type);
        });
        var unique = arr.filter(this.onlyUnique);
        this.Types = unique.sort((a, b) => (a < b) ? -1 : 1);

        arr = [];
        this.catalogService.codes_file.forEach(element => {
            if (element.code_category)
                arr.push(element.code_fix);
        });
        var unique = arr.filter(this.onlyUnique);
        this.Fix = unique.sort((a, b) => (a < b) ? -1 : 1);

        if (target === 'Search...')
            $('#modalAddProc').modal('show');
    }

    filterCategory: string;
    filterSubCategory: string;
    filterApproval: string;
    filterType: string;
    filterFix: string;
    filterVendor: string;
    codes_file: CodesFileModel[] = [];

    isNullOrEmpty(value) {
        return value === '' || value === null || value === undefined;
    }

    applyFilter() {

        this.codes_file.push(...this.catalogService.codes_file);

        if (!this.isNullOrEmpty(this.filterCategory))
            this.codes_file = this.codes_file.filter(t => t.code_category === this.filterCategory);
        if (!this.isNullOrEmpty(this.filterSubCategory))
            this.codes_file = this.codes_file.filter(t => t.code_sub_category === this.filterSubCategory);
        if (!this.isNullOrEmpty(this.filterApproval))
            this.codes_file = this.codes_file.filter(t => t.code_approval === this.filterApproval);
        if (!this.isNullOrEmpty(this.filterType))
            this.codes_file = this.codes_file.filter(t => t.type === this.filterType);
        if (!this.isNullOrEmpty(this.filterFix))
            this.codes_file = this.codes_file.filter(t => t.code_fix === this.filterFix);

        if (!this.isNullOrEmpty(this.filterVendor))
            if (this.catalogService.codes_vendor.some(t => t.vendor === this.filterVendor)) {
                var vendor = this.catalogService.codes_vendor.find(t => t.vendor === this.filterVendor);
                this.codes_file = this.codes_file.filter(t => vendor.codes.some(v => v == t.code_no));
            }

        $('#modalAddProc').modal('hide');
    }

    onVaccine() {
        Swal.fire({
            title: 'Loading...',
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })

        const code = this.catalogService.codes_file.find(t => t.code_name === this.filterText);
        this.petService.pet_brief.brief_hist_code = this.filterText;
        this.petService.pet_brief.brief_hist_category = code.brief_history_category;
        this.petService.pet_brief.client_no = this.clientService.current_client_no;

        this.petService.setupPetBrief()
            .then((res: string) => {
                Swal.close();

                this.petService.getBriefByPetId(this.petService.current_pet_no)

                if (res && res.length > 0) {
                    Swal.fire({
                        title: res,
                        // icon: 'warning',
                        showCancelButton: true,
                        cancelButtonText: 'No',
                        confirmButtonText: 'Yes'
                    }).then((result: any) => {
                        if (result.isConfirmed) {
                            this.petService.pet_brief.confirmed = true;
                            this.onVaccine();
                        }
                    })
                } else {
                    this.petService.pet_brief = new PetBriefModel(0, 0, 0, '', '', '', '', '', 0, false, null);
                    $('#modalAddVaccine').modal('hide')
                    Swal.fire({
                        title: 'Information stored correctly',
                        didOpen: () => {
                        },
                    })
                }
            });
    }

    fillTextbox(buttonValue: string) {
        this.filterText = buttonValue;
        this.isButtonClicked = true;
    }

    positionDropdown(event: MouseEvent): void {
        const button = event.currentTarget as HTMLElement;
        const parent = button.parentElement;
        const menu = parent?.querySelector('.dropdown-menu') as HTMLElement;
        if (!menu) return;

        const rect = button.getBoundingClientRect();

        setTimeout(() => {
            if (!menu.classList.contains('show')) return;

            const menuHeight = menu.offsetHeight || 100;
            const spaceBelow = window.innerHeight - rect.bottom;
            const openUpward = spaceBelow < menuHeight && rect.top > menuHeight;

            menu.style.position = 'fixed';
            menu.style.transform = 'none';
            menu.style.left = rect.left + 'px';
            menu.style.zIndex = '9999';

            if (openUpward) {
                menu.style.top = 'auto';
                menu.style.bottom = (window.innerHeight - rect.top) + 'px';
            } else {
                menu.style.top = rect.bottom + 'px';
                menu.style.bottom = 'auto';
            }
        }, 0);
    }

    getColor(status) {
        if (status == 'R') {
            return this.colors[3]
        }
        else if (status == 'T') {
            return this.colors[2]
        }
        else if (status == 'E') {
            return this.colors[3]
        }
        else if (status == 'T') {
            return this.colors[2]
        }
        else if (status == 'W' || status == 'P') {
            return this.colors[0]
        }
        else {
            return this.colors[4]
        }
    }

    colors = ['#FFADAD', '#FFDA65', '#FDFFB6', '#E4F1EE', '#D9EDF8', '#DEDAF4']

    getStatusOption(status) {
        switch (status) {
            case 'R':
                return ['D- Done', 'P- Print', 'W- Working', 'T - Treatment', 'S - Suggested', 'Q- Quoted', 'X- Delete']
            case 'D':
                return ['E- ', 'X- Delete']
            case 'S':
                return ['R- Request', 'D- Done', 'T- Treatment', 'X- Delete']
            case 'C':
                return ['R- Request', 'D- Done', 'T- Treatment', 'S - Suggested', 'Q- Quoted', 'X- Delete']
            case 'P':
            case 'W':
                return ['E- ', 'D- Done', 'X- Delete']
            case 'F':
            case 'Q':
            case 'T':
                return ['X- Delete']
        }
    }

    getTooltip(item: PetProcsModel) {
        let tooltip = ``;

        if (item.status === 'D') tooltip += `${item.done_date}`;
        else tooltip += `${item.req_date}`;

        tooltip += ` -- ${item.procedure_desc}`;

        if (item.req_by !== '0') tooltip += `  ${item.req_employee_initial}`;

        if (item.status === 'T') tooltip += `   ${item.notes}`;

        if (item.appr_by !== '0' && item.appr_by !== null) tooltip += `  ${item.appr_employee_initial}`;

        if (item.done_by !== '0' && item.done_by !== null) tooltip += `  ${item.done_employee_initial}`;

         tooltip += `   Unit: ${item.unit}   Cost: ${item.cost}`;

        if (item.link_type === INVENT) {           
            if (item.route !== '' && item.route !== null) tooltip += `   Route: ${item.route}`;
        } else {
            let strTemp = '';
            if (item.response1 !== '' && item.response1 !== null) strTemp += `${item.response1}`;
            if (item.response2 !== '' && item.response2 !== null) strTemp += ` / ${item.response2}`;
            if (strTemp !== '') tooltip += `   Resp: ${strTemp}`;
        }

        if (item.location !== '' && item.location !== null) tooltip += `   Location: ${item.location}`;

        return tooltip;
    }

    async statusChanged(item: PetProcsModel, pCodeStatus: string, index: number) {
        let intTotalIdx = 0;
        let i: number, j: number;
        let Status: string
        let strCodeStatus: string;

        strCodeStatus = pCodeStatus;
        if (pCodeStatus.length > 1) {
            strCodeStatus = pCodeStatus.substring(0, 1);
        }

        switch (strCodeStatus) {
            case 'Z':
                return;
                break;
            case 'T':
                this.TreatmentItem = item;
                this.getTreatmentList(item);
                return;
                break;
            default:
                Status = item.status;
                if (strCodeStatus === Status)
                    return;

                let Trans = this.procedureService.displayTran(this.petService.pet_procs);
                index = Trans.findIndex(t => t.Seq === item.tran_sequence);
                let _changeStatus = await this.procedureService.changeStatus(Trans, index, Trans.length, strCodeStatus, Status, 'ref', 1, this.clientService.current_client_no, this.petService.current_pet_no, 1, 'frmWorkScreen');
                if (_changeStatus) {
                    //FillAddTran
                    await this.loadAndRestoreVisible();


                    if (strCodeStatus === 'D' || strCodeStatus === 'F') {

                    } else if (strCodeStatus === "Q") {
                        var PubTrans = this.procedureService.displayTran(this.petService.pet_procs);
                        for (let j = 0; j <= intTotalIdx - 1; j++) {
                            if (PubTrans[j].Seq === PubTrans[i].SupSeq) {
                                i = j;
                                break;
                            } else if (PubTrans[j].Seq === PubTrans[i].Seq) {
                                i = j;
                                break;
                            }
                        }
                    }
                }

                break;
        }

    }

    async statusChangedChild(item: PetProcsModel, pCodeStatus: string, index: number) {
        let Status: string;
        let strLinkStatus: string;

        strLinkStatus = pCodeStatus;
        if (pCodeStatus.length > 1) {
            strLinkStatus = pCodeStatus.substring(0, 1);
        }

        Status = item.status;
        if (strLinkStatus === Status)
            return;

        let Trans = this.procedureService.displayTran(this.petService.pet_procs);
        index = Trans.findIndex(t => t.Seq === item.tran_sequence);
        let _changeStatus = await this.procedureService.changeStatus(Trans, index, Trans.length, strLinkStatus, Status, 'ref', 1, this.clientService.current_client_no, this.petService.current_pet_no, 1, 'frmWorkScreen');
        if (_changeStatus) {
            item.status = strLinkStatus;
            this.cdr.detectChanges();
            Swal.fire({ title: 'Loading...', timerProgressBar: true, didOpen: () => { Swal.showLoading(); } });
            await this.loadAndRestoreVisible();
            this.cdr.detectChanges();
            await new Promise(resolve => setTimeout(resolve, 50));
            Swal.close();
        }
    }

    // keyword = 'code_name';
    // data = [
    //     {
    //         id: 1,
    //         name: 'Georgia'
    //     },
    //     {
    //         id: 2,
    //         name: 'Usa'
    //     },
    //     {
    //         id: 3,
    //         name: 'England'
    //     }
    // ];


    selectEvent(item) {
        // do something with selected item
    }

    onChangeSearch(val: any) {
        //debugger;
        this.buscador_activo = true;
        // fetch remote data from here
        // And reassign the 'data' which is binded to 'data' property.
        val = this.filterText.toUpperCase();
        this.suggestedWordsArray.push(...this.catalogService.codes_file);

        // if (!this.isNullOrEmpty(this.filterCategory))
        this.suggestedWordsArray = this.suggestedWordsArray.filter(t => t.code_name.startsWith(val) || t.code_category.startsWith(val) || t.code_sub_category.startsWith(val));
        // if (!this.isNullOrEmpty(this.filterSubCategory))
        //     this.codes_file = this.codes_file.filter(t => t.code_sub_category === this.filterSubCategory);
        // if (!this.isNullOrEmpty(this.filterApproval))
        //     this.codes_file = this.codes_file.filter(t => t.code_approval === this.filterApproval);
        // if (!this.isNullOrEmpty(this.filterType))
        //     this.codes_file = this.codes_file.filter(t => t.type === this.filterType);
        // if (!this.isNullOrEmpty(this.filterFix))
        //     this.codes_file = this.codes_file.filter(t => t.code_fix === this.filterFix);

        // if (!this.isNullOrEmpty(this.filterVendor))
        //     if (this.catalogService.codes_vendor.some(t => t.vendor === this.filterVendor)) {
        //         var vendor = this.catalogService.codes_vendor.find(t => t.vendor === this.filterVendor);
        //         this.codes_file = this.codes_file.filter(t => vendor.codes.some(v => v == t.code_no));
        //     }
    }

    onFocused(e) {
        // do something when input is focused
    }

    procs = '[{"tran_sequence":2911063,"sup_sequence":0,"link_no":2212,"link_type":0,"item_type":"","unit":"1","unit_cost":"0.0000","status":"Q","inv_date":"01/01/1900 00:00:00","req_date":"11/12/2020 10:27:27","appr_date":"11/12/2020 10:27:27","done_date":"11/12/2020 10:27:27","req_by":"188","req_employee_initial":"kd","done_by":"188","done_employee_initial":"kd","appr_by":"188","appr_employee_initial":"kd","inv_by":"0","inv_employee_initial":"REF","pstatus":"False","tax":"0","response1":"","response2":"","approval":"","chk_cost":"","cost":"0.0000","sub_cost":"0.0000","distr_method":"","route":"","start_time":"01/01/1900 00:00:00","moved":"False","printed":"False","recall_date":"01/01/1900 00:00:00","clinic_no":"1","optional":"False","rerequest":null,"location":"","basechg":"","code_no":0,"code_type":0,"code_name":"BOARD","procedure_desc":"BOARDING"},{"tran_sequence":2911069,"sup_sequence":0,"link_no":2194,"link_type":0,"item_type":"R","unit":"1","unit_cost":"13.9400","status":"Q","inv_date":"01/01/1900 00:00:00","req_date":"11/12/2020 10:27:36","appr_date":"11/12/2020 10:27:36","done_date":"11/12/2020 10:27:36","req_by":"188","req_employee_initial":"kd","done_by":"188","done_employee_initial":"kd","appr_by":"188","appr_employee_initial":"kd","inv_by":"0","inv_employee_initial":"REF","pstatus":"False","tax":"0","response1":"","response2":"","approval":"","chk_cost":"","cost":"13.9400","sub_cost":"0.0000","distr_method":"","route":"","start_time":"01/01/1900 00:00:00","moved":"False","printed":"True","recall_date":"01/01/1900 00:00:00","clinic_no":"1","optional":"False","rerequest":null,"location":"","basechg":"","code_no":0,"code_type":0,"code_name":"RAB OB","procedure_desc":"RABIES OBSERVATION"},{"tran_sequence":2911071,"sup_sequence":0,"link_no":1272,"link_type":1,"item_type":"Y","unit":"1","unit_cost":"21.0000","status":"Q","inv_date":"01/01/1900 00:00:00","req_date":"11/12/2020 10:29:00","appr_date":"11/12/2020 10:29:02","done_date":"11/12/2020 10:29:02","req_by":"188","req_employee_initial":"kd","done_by":"188","done_employee_initial":"kd","appr_by":"3","appr_employee_initial":"tdm","inv_by":"0","inv_employee_initial":"REF","pstatus":"False","tax":"0","response1":"","response2":"","approval":"","chk_cost":"","cost":"21.0000","sub_cost":"0.0000","distr_method":"","route":"S","start_time":"01/01/1900 00:00:00","moved":"False","printed":"True","recall_date":"01/01/1900 00:00:00","clinic_no":"1","optional":"False","rerequest":null,"location":"Left Hip","basechg":"","code_no":0,"code_type":0,"code_name":"DHLP-P","procedure_desc":null},{"tran_sequence":2911072,"sup_sequence":0,"link_no":1029,"link_type":0,"item_type":"R","unit":"1","unit_cost":"17.0000","status":"Q","inv_date":"01/01/1900 00:00:00","req_date":"11/12/2020 10:29:16","appr_date":"11/12/2020 10:29:16","done_date":"11/12/2020 10:29:16","req_by":"188","req_employee_initial":"kd","done_by":"188","done_employee_initial":"kd","appr_by":"3","appr_employee_initial":"tdm","inv_by":"0","inv_employee_initial":"REF","pstatus":"False","tax":"0","response1":"","response2":"","approval":"","chk_cost":"Y","cost":"17.0000","sub_cost":"0.0000","distr_method":" ","route":"","start_time":"01/01/1900 00:00:00","moved":"False","printed":"True","recall_date":"01/01/1900 00:00:00","clinic_no":"1","optional":"False","rerequest":null,"location":"Right Hip","basechg":"","code_no":0,"code_type":0,"code_name":"RAB1","procedure_desc":"RABIES VACCINE  1 YR"},{"tran_sequence":2911073,"sup_sequence":0,"link_no":476,"link_type":1,"item_type":"Y","unit":"1","unit_cost":"17.0000","status":"Q","inv_date":"01/01/1900 00:00:00","req_date":"11/12/2020 10:29:24","appr_date":"11/12/2020 10:29:25","done_date":"11/12/2020 10:29:25","req_by":"188","req_employee_initial":"kd","done_by":"3","done_employee_initial":"tdm","appr_by":"3","appr_employee_initial":"tdm","inv_by":"0","inv_employee_initial":"REF","pstatus":"False","tax":"0","response1":"","response2":"","approval":"","chk_cost":"","cost":"17.0000","sub_cost":"0.0000","distr_method":"","route":"R","start_time":"01/01/1900 00:00:00","moved":"False","printed":"True","recall_date":"01/01/1900 00:00:00","clinic_no":"1","optional":"False","rerequest":null,"location":" ","basechg":"","code_no":0,"code_type":0,"code_name":"BOR-N","procedure_desc":"CLEAN/POLISH TEETH"},{"tran_sequence":2911091,"sup_sequence":0,"link_no":751,"link_type":0,"item_type":"P","unit":"1","unit_cost":"0.0000","status":"Q","inv_date":"01/01/1900 00:00:00","req_date":"11/12/2020 12:05:50","appr_date":"11/12/2020 12:05:59","done_date":"11/12/2020 12:05:59","req_by":"276","req_employee_initial":"mgh","done_by":"3","done_employee_initial":"tdm","appr_by":"3","appr_employee_initial":"tdm","inv_by":"0","inv_employee_initial":"REF","pstatus":"False","tax":"0","response1":"","response2":"","approval":"","chk_cost":"","cost":"167.5000","sub_cost":"0.0000","distr_method":"","route":"","start_time":"01/01/1900 00:00:00","moved":"False","printed":"True","recall_date":"01/01/1900 00:00:00","clinic_no":"1","optional":"False","rerequest":null,"location":"","basechg":"","code_no":0,"code_type":0,"code_name":"CANA","procedure_desc":"CANINE: ANNUAL VISIT"}]'

    //added by harold for VitalSign Tab Procedure

    ///////////////////////////////////////////////////////////////////////////////////////
    //TREATMENT MODAL//////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////

    addRecurringTreatment() {
        let start_date = new Date();
        if (this.procedureService.tx_setup_array.length > 0) {
            let index = this.procedureService.tx_setup_array.length - 1;
            let days = this.getDaysTreatment(index);
            let date = new Date(this.procedureService.tx_setup_array[index].start_date);
            start_date.setDate(date.getDate() + days + 1);
            let no_times = this.procedureService.tx_setup_array[index].no_times;
            let repeat_in = this.procedureService.tx_setup_array[index].repeat_in;
            let total_times = this.procedureService.tx_setup_array[index].total_times;
            this.procedureService.tx_setup_array.push(new TxSetupModel(0, start_date.toISOString().split('T')[0], no_times, repeat_in, total_times, false, false));
        }
        else {
            let freq;
            let no_times = 0;
            switch (freq) {
                case 'SID PM':
                    no_times = 0;
                    break;
                case 'SID':
                    no_times = 1;
                    break;
                case 'BID':
                    no_times = 2;
                    break;
                case 'TID':
                    no_times = 3;
                    break;
                case 'QID':
                    no_times = 4;
                    break;
            }
            this.procedureService.tx_setup_array.push(new TxSetupModel(0, start_date.toISOString().split('T')[0], no_times.toString(), '', '', false, false));
        }
    }

    public deleteRecurringTreatment(index: number) {
        this.procedureService.tx_setup_array.splice(index, 1);
    }

    public getDaysTreatment(index: number) {
        let days = Number(this.procedureService.tx_setup_array[index].no_times);
        let total_times = parseInt(this.procedureService.tx_setup_array[index].total_times);

        if (total_times > 0 && days > 0)
            return total_times / days;
        else
            return 0;
    }

    async saveTreatment() {
        let _trans = this.procedureService.displayTran(this.petService.pet_procs);
        let _intIndex = _trans.findIndex(t => t.Seq === this.TreatmentItem.tran_sequence);
        Swal.fire({
            title: 'Saving...',
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
        let success = await this.procedureService.buildTreatGen_array(_trans, _intIndex, _trans.length);
        if (success > 0) {

            $('#treatmentModal').modal('hide');
            let TchangeStatus = await this.procedureService.changeStatus(_trans, _intIndex, _trans.length, "T", this.TreatmentItem.status, 'ref', 1, this.petService.current_client_no, this.petService.current_pet_no, 1, 'frmWorkScreen');
            if (TchangeStatus) {
                Swal.fire({
                    title: 'Success',
                    text: 'Treatment saved correctly',
                    icon: 'success'
                });
                Swal.fire({
                    title: 'Loading...',
                    timerProgressBar: true,
                    didOpen: () => {
                        Swal.showLoading()
                    },
                })
                //FillAddTran
                await this.loadProceduresForCurrentPet();
                Swal.close();
            }
        }
        else {
            Swal.fire({
                title: 'Error',
                text: 'There was an error saving the treatment',
                icon: 'error'
            });
        }
        Swal.close();
        $('#treatmentModal').modal('hide');
    }


    getTreatmentList(item: PetProcsModel) {
        this.procedureService.tx_setup_array = [];
        let _trans = this.procedureService.displayTran(this.petService.pet_procs);
        let _intIndex = _trans.findIndex(t => t.Seq === item.tran_sequence);
        Swal.fire({
            title: 'Loading...',
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
        $('#treatmentModal').modal('show');
        this.procedureService.getTreatmentProc(_trans[_intIndex].Seq, this.petService.pet.pet_no).subscribe(res => {
            if (res) {
                if (Array.isArray(res)) {
                    res.forEach(item => {
                        this.procedureService.tx_setup_array.push(
                            new TxSetupModel(
                                item.treatmentID,
                                this.formatDate(item.dtpDate),
                                item.txtNoPerDay,
                                String(item.txtDays),
                                String(item.txtTotal),
                                item.immediately,
                                item.next
                            )
                        );
                    });
                    if (res.length == 0) {
                        this.addRecurringTreatment();
                    }
                }

            }
        });
        Swal.close();
    }

    clearinput() {
        this.filterText = "";
        this.txtchar = "";
        this.buscador_activo = false;
        this.buscador_activo_status = false;
    }

    processNextEstItem() {
        if (this.estItemQueue.length === 0) return;
        const proc = this.estItemQueue.shift();
        this.filterText = proc.code_name;
        this.txtchar = 'R';
        this.onStatInput();
    }

    formatDate(dtpDate: any): string {
        const date = new Date(dtpDate);
        return date.toISOString().substring(0, 10)
    }

    async updateRespNotes(notes: RespNotesModel[]) {
        await this.procedureService.updateRespNotes(notes)
            .then(() => {
                $('#modalRespNotes').modal('hide');
                //Swal.fire({ title: 'Results saved successfully' });
            })
            .catch(() => {
                Swal.fire({ title: 'Error saving results', icon: 'error' });
            });
    }
}

